<template>
  <div class="event-code-label">
    <span style="flex: 1">
      {{ code }}
    </span>
    <v-divider vertical style="height: 18px" />
    <button class="copy-button" @click.stop="copyScannerCodeToClipboard">
      <v-icon>content_copy</v-icon>
    </button>
    <div v-if="displaySavedToClipboard" class="saved-to-clipboard-container">
      {{ adminText('shared.clipboard', 'Saved to clipboard!') }}
    </div>
  </div>
</template>

<script>
import AdminContext from '@/admin-i18n/context'
export default {
  mixins: [AdminContext],
  name: 'event-code-label',
  props: {
    code: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      displaySavedToClipboard: false,
    }
  },
  methods: {
    async copyScannerCodeToClipboard() {
      await navigator.clipboard.writeText(this.code)
      this.displaySavedToClipboard = true
      setTimeout(() => {
        this.displaySavedToClipboard = false
      }, 3000)
    },
  },
}
</script>

<style scoped>
.event-code-label {
  display: flex;
  height: 2.5rem;
  align-items: center;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;

  border-radius: 0.5rem;
  background: #efefef;
  mix-blend-mode: multiply;
}

.event-code-label span {
  overflow: hidden;
  color: #0277bd;
  text-align: center;
  text-overflow: ellipsis;
  font-family: 'Source Code Pro';
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  padding: 0 1rem;
}

.copy-button {
  display: flex;
  padding: 0.75rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  align-self: stretch;
}

.copy-button:hover {
  background: #d9d9d9;
}

.saved-to-clipboard-container {
  background: #cee4f2;
  position: absolute;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  flex: 1 0 0;
  align-self: stretch;
  overflow: hidden;
  color: #0277bd;
  text-align: center;
  text-overflow: ellipsis;
  font-family: 'Source Sans Pro';
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
}
</style>
